import { render, staticRenderFns } from "./DetailChanges.vue?vue&type=template&id=4ad7648b&scoped=true"
import script from "./DetailChanges.vue?vue&type=script&lang=js"
export * from "./DetailChanges.vue?vue&type=script&lang=js"
import style0 from "./DetailChanges.vue?vue&type=style&index=0&id=4ad7648b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7648b",
  null
  
)

export default component.exports